import React, { useState, useEffect } from "react";
import { BRAND_DETAILS_LISTING_COLUMNS } from "../../../utils/constant";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  TableSortLabel,
  Box,
  IconButton
} from "@mui/material";
import RecordNotFound from "../../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import AddBrand from "./AddBrand";
import ClearIcon from "@mui/icons-material/Clear";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_BRAND_VALIDATIONS } from "../../../utils/Validation";
import Add from "@mui/icons-material/Add";
import { visuallyHidden } from "@mui/utils";
import {
  ChangeBrandBrickMappingStatusService,
  onUpdateBrandService,
  onAddBrandService,
} from "../../../services/MasterDataManagementService";
import useGlobalState from "../../../Context";
import EditIcon from "@mui/icons-material/Edit";

const BrandList = ({
  totalElements,
  brandList,
  onSearch,
  fetchBrandsDetails,
  handleTableChanges,
  setLoading,
  showNotification,
  categoryList,
  fetchCategoryList,
  fetchBrickListWithorWithoutFamily,
  brickList,
  setBrandList,
  fetchProductFamilyList,
  productFamilyList,
  fetchAllBrandsList,
  allBrands,
  noRecord,
}) => {
  const [searchedRows, setSearchedRows] = useState(brandList);
  const [brandNameSearch, setBrandNameSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [clearSearch, setClearSearch] = useState(false);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddBrandDialog, setOpenAddBrandDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [brandId, setBrandId] = useState(0);
  const [brickId, setBrickId] = useState("");
  const [formData, setFormData] = useState({});
  const [brickName, setBrickName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [selected, setSelected] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [isAddBrand, setIsAddBrand] = useState(false);
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [familyName, setFamilyName] = useState("");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("brandName");
  const [sortValue, setSortValue] = useState("ASC");
  const [diableFamilyDropdown, setDisableFamilyDropdown] = useState(true);
  const [diableBrickDropdown, setDisableBrickDropdown] = useState(true);
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserId = auth.ldapParam.userId;
  const [searchValue_, setsearchValue_] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserId,
    active: 1,
  });

  const formOption = {
    resolver: yupResolver(ADD_BRAND_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm(formOption);

  useEffect(() => {
    reset(formData);
    
  }, [openAddBrandDialog]);

  useEffect(() => {
  

    setSearchedRows(brandList);
  }, [brandNameSearch, brandList]);

  const searchText = async (e) => {
    setSearchValue(e.target.value);
    setBrandNameSearch("");
    e.target.value === "" ? setClearSearch(false) : setClearSearch(true);
    if (e.target.value === "") {
      // await fetchBrandsDetails("brandName", true);
      onclickClear()
    }
  };

  const handleClickOpenBrandDialog = () => {
    fetchCategoryList();
    fetchAllBrandsList();
    setOpenAddBrandDialog(true);
  };

  const handleCloseBrandDialog = () => {
    setOpenAddBrandDialog(false);
    setIsEditMode(false);
    setFormData({});
    setBrickId("");
    setIsUpdateButton(true);
    setBrandName("");
    setIsAddBrand(false);
  };

  const onClickAddBrandButton = () => {
    if (isAddBrand) {
      setIsAddBrand(false);
    } else {
      setIsAddBrand(!isAddBrand);
      setValue("brandName", undefined);
      setValue("brandId", "0");
    }
  };

  const searchOnClick = async (type) => {
    try {
      setLoading(true);
      const requestBody = {
        status: true,
        pageNumber: 0,
        pageSize: rowsPerPage ?? 10,
        search: searchValue && searchValue.trim(),
      };
      setsearchValue_(searchValue)
      setIsSearchBtnClick(true);
      setSelected([]);
      setDisbaleUpdateButton(true)
      await onSearch(requestBody, searchValue && searchValue.trim());
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    setBrandNameSearch(searchValue && searchValue.trim());
  };

  const onclickClear = async () => {
   
    const paginationObject = {
      pageNumber:0,
      pageSize: rowsPerPage ?? 10,
      };
      setSelected([]);
      setsearchValue_(null)
      setDisbaleUpdateButton(true)
    await fetchBrandsDetails("brandName", false,null,paginationObject);
    
    setSearchValue("");
    setPage(0);
    setMaxPage(0);
    //setRowsPerPage(10);
    setClearSearch(false);
    setBrandNameSearch("");
    setIsSearchBtnClick(false);
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };
    
    await handleTableChanges(paginationValues, false, sortValue, orderBy,searchValue_);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(paginationValues, true, sortValue, orderBy,searchValue_);
    }
    setPage(newPage);
  };

  const onAddEditBrandSubmit = async (data) => {
    try {
      let obj = {
        brandName: brandName ? brandName.trim() : data.brandName.trim(),
        categoryName,
        brickName,
        productFamilyName: familyName,
        productFamilyId: parseInt(data.productCatFamilyMappingId),
        categoryId: parseInt(data.categoryId),
        brickId: parseInt(data.brickId),
        brandId: isAddBrand ? null : brandId,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.createdBy,
        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        active: formValues.active ? true : false,
      };
      const res = !isEditMode
        ? await onAddBrandService(obj)
        : await onUpdateBrandService(obj, data.brandBrickMappingId);

      if (res.statusCode === 6) {
        const newBrandList = [...brandList];
        const index = newBrandList.findIndex((x) => x.brandId === brandId);
        newBrandList[index] = { ...brandList[index], ...obj };
        setBrandList(newBrandList);
        handleCloseBrandDialog(false);
        setIsUpdateButton(true);
        setSelected([]); setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onclickClear()
        // if (!isEditMode) {
        //   setPage(0);
        //   setMaxPage(0);
         
        //   const timer = setTimeout(async () => {
        //     await fetchBrandsDetails("brandName", true);
        //   }, 1000);
        //   return () => clearTimeout(timer);
        // }
      } else {
        handleCloseBrandDialog(false);
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      handleCloseBrandDialog(false);
      showNotification("Error", "Faild to add brand", "error");
      throw err;
    }
  };

  const handleClickEditBrand = (item) => {
    if (item) {
      reset(item);
    }
    if (item.isSelect) {
      setIsAddBrand(!isAddBrand);
    } else {
      setIsAddBrand(false);
    }
    fetchCategoryList();
    fetchAllBrandsList();
    fetchProductFamilyList(item.categoryId);
    fetchBrickListWithorWithoutFamily(item.productCatFamilyMappingId);
    setOpenAddBrandDialog(true);
    setIsEditMode(true);
    setBrandId(item?.brandId);
    setBrickId(item?.brickId);
    setFamilyName(item?.productFamilyName);
    setBrickName(item?.brickName);
    setCategoryName(item?.categoryName);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item.createdBy ? item.createdBy : 1,
      active: item?.mappingIsActive ? true : false,
    });
    setFormData({ ...item });
  };

  const onFamilyClick = (id, name) => {
    fetchBrickListWithorWithoutFamily(id);
    setFamilyName(name);
    setDisableBrickDropdown(false);
  };

  const onCategoryClick = (id, cateName) => {
    setCategoryName(cateName);
    fetchProductFamilyList(id);   
    setDisableFamilyDropdown(false);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - brandList.length) : 0;

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = brandList.map((currentRow) => {
     // console.log('currentRow',currentRow)
      if (currentRow.brandBrickMappingId === id) {
        return {
          ...currentRow,
          mappingIsActive: event.target.checked,
        };
      }
      
      return currentRow;
    });
   
    setBrandList(newSearchedRow);
  };

  const onChangeStatusSubmit = async () => {
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = brandList.find(
        (record) => record.brandBrickMappingId === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.mappingIsActive,
          brandBrickMappingId: tempItem.brandBrickMappingId,
        });
      }
    });
    try {
      //console.log('resultRecords',resultRecords)
      const res = await ChangeBrandBrickMappingStatusService(resultRecords);
      if (res.statusCode == "6") {
       
        setSelected([]);
        showNotification("Success", res.message, "success");
        //setPage(0);
        setDisbaleUpdateButton(true);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    const paginationObject = {
      pageNumber: 0,
      pageSize:rowsPerPage?rowsPerPage: 10,
     
    };
    setSelected([]);
    setDisbaleUpdateButton(true)
    fetchBrandsDetails(property, isAsc,searchValue_ && searchValue_.trim(),paginationObject);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
    //setSearchValue("");
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid container spacing={2} sx={{ px: 0 }} display="flex">
          <Grid item xs={6} md={4}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6"
            >
              Brand Listing ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={6} md={8}>
            <Typography align="right">
              <div className="searchContainer">
              
                <input
                  type="text"
                  placeholder="By Brand Name"
                  onChange={searchText}
                  className="searchInput2"
                  value={searchValue}
                />
                <IconButton disabled={searchValue === ""} className={searchValue === "" ? 'searchIcon':'filPrimaryColor searchIcon'}>
                <SearchIcon
                  //className="searchIcon"
                  onClick={() => searchOnClick("brandName")}
                />
                </IconButton>
                {clearSearch && (
                  <ClearIcon
                    sx={{ fontSize: "22px", color: "red" }}
                    className="brandSearchClear"
                    onClick={onclickClear}
                  />
                )}
              </div>
              <Tooltip title="Add Brand">
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenBrandDialog();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add Brand
                </Button>
              </Tooltip>
              <Tooltip title="Update Brand Status">
                <span>
                <Button
                  variant="contained"
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  onClick={onChangeStatusSubmit}
                  disabled={disableUpdateButton}
                >
                  Status Update
                  {selected.length !== 0 &&
                    ` (${Object.keys(selected).length})`}
                </Button>
                </span>
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={4} sx={{ mt: 2 }}>
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small"
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(
                            row.brandBrickMappingId
                          );
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              tabIndex={-1}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              // key={row.brandBrickMappingId}
                              key={index}
                            >
                              <TableCell size="small" key={"brandName"}>
                                {row["brandName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"categoryName"}>
                                {row["categoryName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"productFamilyName"}>
                                {row["productFamilyName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"brickName"}>
                                {row["brickName"] ?? "-"}
                              </TableCell>
                              <TableCell align="left">
                                {" "}
                                <Checkbox
                                  color="primary"
                                  classes={{root: 'custom-checkbox-root'}}
                                  checked={
                                    (isItemSelected, row.mappingIsActive)
                                  }
                                  onClick={(event) =>
                                    handleActiveChange(
                                      event,
                                      row.brandBrickMappingId
                                    )
                                  }
                                  inputProps={{
                                    "aria-labelledby": labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell>
                                {/* <Button
                                  variant="outlined"
                                  onClick={() => handleClickEditBrand(row)}
                                >
                                  Edit
                                </Button> */}
                                <EditIcon
                                  sx={{ fontSize: "20px", cursor: "pointer",color:'#567aac', height: "18px", 
                                  width: "18px"  }}
                                  // className="brandSearchClear"
                                  onClick={() => handleClickEditBrand(row)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={6}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={6} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddBrand
              openDialog={openAddBrandDialog}
              handleClose={handleCloseBrandDialog}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              categoryList={categoryList}
              onFamilyClick={onFamilyClick}
              onCategoryClick={onCategoryClick}
              onAddEditBrandSubmit={onAddEditBrandSubmit}
              brickList={brickList}
              formData={formData}
              brickId={brickId}
              isEditMode={isEditMode}
              setBrickName={setBrickName}
              setFamilyName={setFamilyName}
              setCategoryName={setCategoryName}
              productFamilyList={productFamilyList}
              allBrands={allBrands}
              setBrandName={setBrandName}
              onClickAddBrandButton={onClickAddBrandButton}
              isAddBrand={isAddBrand}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              setValue4={setValue}
              setBrandId={setBrandId}
              diableFamilyDropdown={diableFamilyDropdown}
              diableBrickDropdown={diableBrickDropdown}
              setValue = {setValue}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default BrandList;

function EnhancedTableHead({ onRequestSort, order, orderBy }) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow key={"1"}>
        {BRAND_DETAILS_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.brandBrickMappingId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" || headCell.id === "active") && true
              }
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
